import { baseApi } from '@/services'
import { IDocRequest } from '@/types/unlock'

export const docRequestApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDocRequests: builder.query<IDocRequest[], string | string[]>({
      query: (externalId) => `v2/multi-doc-request/?application__external_id=${externalId}`,
      providesTags: ['DocRequest'],
    }),
    createDocRequest: builder.mutation<IDocRequest, any>({
      query: (body: IDocRequest) => ({
        method: 'POST',
        url: 'v2/multi-doc-request/',
        body,
      }),
      invalidatesTags: ['Message', 'DocRequest'],
    }),
  }),
})

export const { useGetDocRequestsQuery, useCreateDocRequestMutation } = docRequestApi
